<ling-input-base
  [label]="label"
  [info]="info"
  [isRequired]="isRequired"
  [removeButton]="removeButton"
  (removeButtonPress)="onRemoveButtonPressed()"
  [isEditButton]="isEditButton"
  [editButtonInfo]="editButtonInfo"
  (editButtonPress)="editButtonPress.emit()"
  [disabledInput]="disabledInput"
  [error]="error"
>
  <div
    class="ling-line-input-wrapper"
    *ngIf="
      (type === 'text' ||
        type === 'number' ||
        type === 'password' ||
        type === 'email' ||
        type === 'search') &&
      !asBoxes
    "
  >
    <div class="ling-search-icon" *ngIf="isSearch"></div>
    <button
      type="button"
      class="ling-clear-button"
      *ngIf="isSearch && input.value"
      (click)="clearSearch()"
    >
      <mat-icon fontIcon="close"></mat-icon>
    </button>
    <input
      #input
      class="ling-input ling-line-input"
      [class.padded-right]="type === 'password' || type === 'search'"
      [type]="actualInputType"
      [class.ling-line-input_search]="isSearch"
      [class.error-input]="error"
      [class.in-focus]="isFocused"
      [value]="control.value"
      [maxLength]="maxLength"
      (focusout)="onTouched()"
      (keydown.tab)="onTabPressed()"
      [autocomplete]="type === 'password' ? 'off' : autocomplete"
      (change)="onLineTextInput($event)"
      (input)="processValueOnInputEvent(this.control, type, onChange, $event)"
      [placeholder]="placeholder"
    />
    <div
      class="password-visibility-control"
      (click)="onPasswordVisibilityToggle()"
      *ngIf="type === 'password'"
    >
      <mat-icon
        fontIcon="visibility_off"
        [class.password-visibility-control-hidden]="!isPasswordVisible"
      ></mat-icon>
      <mat-icon
        fontIcon="visibility"
        [class.password-visibility-control-hidden]="isPasswordVisible"
      ></mat-icon>
    </div>
  </div>

  <div
    class="ling-boxes-input"
    [class.error-input]="error"
    [class.in-focus-with-offset]="isFocused"
    *ngIf="asBoxes"
  >
    <div
      class="ling-input-box-container"
      *ngFor="let box of boxes; let i = index"
      (click)="onBoxClick(i, $event)"
    >
      <input
        type="text"
        class="input-box-input"
        autocomplete="do-not-autocomplete"
        #inputBox
        (beforeinput)="onBoxInput(i, $event)"
        [disabled]="control.value.toString().length < i"
        [value]="getBoxValue(i)"
      />
    </div>
  </div>

  <div class="ling-textarea-container" *ngIf="type === 'textarea'">
    <textarea
      #input
      [class.in-focus]="isFocused"
      class="ling-input ling-textarea"
      [ngStyle]="{
        height: textAreaHeight ?? '5rem',
        'border-radius': borderRadius
      }"
      [class.error-input]="error"
      rows="10"
      [maxLength]="maxTextAreaLength"
      [value]="control.value"
      (focusout)="onTouched()"
      (change)="
        processValueOnInputEvent(this.control, type, onChange, $event);
        valueChange.emit($event);
        onTouched()
      "
      (input)="
        valueChange.emit($any($event.target).value);
        onChange($any($event.target).value)
      "
      [placeholder]="placeholder"
    >
    </textarea>
    <div class="ling-textarea-handle"></div>
  </div>

  <div
    *ngIf="type === 'or'"
    class="ling-input ling-or-control"
    #input
    [class.in-focus-with-offset]="isFocused"
  >
    <input type="checkbox" [hidden]="true" #orControl [formControl]="control" />
    <div
      class="ling-or-option ling-or-option-left"
      [class.ling-or-option-selected]="control.value === true"
      (click)="onOrControlOptionClick(orControl, true)"
    >
      {{ orOptions.true }}
    </div>
    <div
      class="ling-or-option ling-or-option-right"
      [class.ling-or-option-selected]="control.value === false"
      (click)="onOrControlOptionClick(orControl, false)"
    >
      {{ orOptions.false }}
    </div>
  </div>

  <mat-slide-toggle
    *ngIf="type === 'toggle'"
    #input
    [class.in-focus]="isFocused"
    [class.error-input]="error"
    [formControl]="control"
  >
  </mat-slide-toggle>

  <div
    *ngIf="type === 'checkbox'"
    class="ling-checkbox-input"
    [class.error-input]="error"
  >
    <mat-checkbox [formControl]="control">
      <ng-content></ng-content>
    </mat-checkbox>
  </div>

  <div
    class="ling-counter-input"
    *ngIf="type === 'counter'"
    [class.in-focus]="isFocused"
    [class.error-input]="error"
  >
    <div class="counter-input-container">
      <input
        #input
        class="counter-input"
        [type]="'number'"
        (focusout)="onTouched()"
        [placeholder]="placeholder"
        [class.counter-input_disabled]="disabledInput"
        [disabled]="disabledInput"
        (change)="valueChange.emit($any($event.target).value); onTouched()"
        (input)="onCounterInput($event)"
        (keydown)="blockCounterChars($event)"
      />
      <span
        class="counter-input-value-overlay"
        *ngIf="currency && !isFocused && control.value"
        >{{ control.value | currency: currency }}</span
      >
    </div>
    <label
      [for]="input"
      class="counter-label"
      [class.counter-label_disabled]="disabledInput"
      >{{ counterLabel }}</label
    >
  </div>

  <div
    class="ling-line-input-wrapper ling-color-input"
    *ngIf="type === 'color'"
  >
    <input
      #input
      class="ling-input ling-line-input ling-color-input__hex-input"
      [type]="actualInputType"
      [class.error-input]="error"
      [class.in-focus]="isFocused"
      [value]="control.value"
      [maxLength]="maxLength"
      (focusout)="onTouched()"
      (keydown.tab)="onTabPressed()"
      (change)="onLineTextInput($event)"
      (input)="processValueOnInputEvent(this.control, type, onChange, $event)"
      [placeholder]="placeholder"
    />
    <input
      class="ling-color-input__color-input"
      type="color"
      [value]="control.value?.length === 7 ? control.value : '#000000'"
      (input)="control.setValue($any($event.target).value)"
    />
  </div>
</ling-input-base>
